import { Component, Input, OnChanges } from '@angular/core';
import { ResultListValueField } from '../../model/result-list-value-field';
import {
  CalculatorColorConfig,
  defaultCalculatorColorConfig,
} from '../../../calculator/calculator-components/simple-calculator/calculator-color-config';

@Component({
  selector: 'psc-solar-assessment',
  templateUrl: './solar-assessment.component.html',
})
export class SolarAssessmentComponent implements OnChanges {

  @Input() solarCalculatorResult: {
    selfSufficiencyPercentage: string | number;
    systemCapacity: string | number;
    area: string | number;
  };
  @Input() smallTitle: boolean;

  solarAssessmentValues: ResultListValueField[];
  @Input() colorConfig: CalculatorColorConfig = defaultCalculatorColorConfig;
  ngOnChanges() {
    this.setValues();
  }

  private setValues() {
    this.solarAssessmentValues = [
      {
        labelKey: 'effectiveness',
        value: this.solarCalculatorResult.selfSufficiencyPercentage,
        numberOfDecimals: 0,
        unit: '%',
      },
      {
        labelKey: 'system-capacity',
        value: +this.solarCalculatorResult.systemCapacity,
        unit: 'kW',
      },
      {
        labelKey: 'solar-area',
        value: this.solarCalculatorResult.area,
        unit: 'm²',
      },
    ];
  }
}
